import React from 'react';

export const Page404  = (props) => {
    return(
        <main>
            <h2>404 :(</h2>
            <p>Sorry page doesn't exist</p>
        </main>
    )
};


// WEBPACK FOOTER //
// ./src/containers/Page404/index.js